import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useContext,
} from "react";
import { CustomIcons } from "../../../Components/helpers/Helpers";
import {
  Autocomplete,
  Button,
  TextField,
  Grid,
  Divider,
  Slide,
  Alert,
} from "@mui/material/";

// ICONS OPEN
import {
  Delete,
  ArrowForwardIos,
  InsertDriveFile,
  Cancel,
} from "@mui/icons-material";

import UploaderDialog from "./DocsComponents/UploaderDialog";
import ArchivosMostrar from "./DocsComponents/ArchivosMostrar";
import {
  DocsContext,
  PermissionContext,
} from "../../../Components/Context/Context";
import { CustomButtonPlusIcon } from "../../../Components/Common/Design/CustomButtonPlusIcon";
// ICONS CLOSED

import dayjs from "dayjs";
import api from "../../../api/axios";
import { normalizeFolderDisplayName } from "./docsFolderDisplay";

const DocsContent = ({
  sectionId = false,
  caseId,
  nextTask,
  userLogged,
  dataCase,
  activeTask,
  activeFlow,
  setUpdatedCase,
  updatedCase,
}) => {
  const { can } = useContext(PermissionContext);
  const canUploadDocs = can("cases", "docs");
  const canDelete = can("cases", "delete");
  const canDeleteDocs = can("cases", "deletedocs");
  const canEdit = can("cases", "edit");

  const [caseFiles, setCaseFiles] = useState([]);

  const Swal = require("sweetalert2");
  // Estados principales del componente
  const { docsChangedFlag, setDocsChangedFlag, setDocsLoading } =
    useContext(DocsContext);
  const [selectedFolderTypeOption, setSelectedFolderTypeOption] =
    useState(null); // Carpeta seleccionada
  const [selectedDocs, setSelectedDocs] = useState({});
  const docsRenderResolverRef = useRef(null);

  const [message, setMessage] = useState(
    activeTask?.message != "" ? activeTask?.message : "",
  );

  const getDocsContentStatus = activeTask?.status == 0;

  const getTaskOrderById = (taskId) => {
    const flow = (dataCase?.completeFlow || []).find(
      (item) => Number(item?.id) === Number(taskId),
    );
    return Number(flow?.order || 0);
  };

  const activeTaskOrder = getTaskOrderById(activeTask?.task_id);
  const hasLaterPendingTask = (dataCase?.tasks || []).some(
    (task) =>
      Number(task?.status) === 0 &&
      getTaskOrderById(task?.task_id) > activeTaskOrder,
  );

  const shouldShowCompletePendingTaskButton =
    getDocsContentStatus && hasLaterPendingTask;

  // console.log(activeFlow, "activeFlow");
  // console.log(activeFlow, "activeFlow");
  // console.log(getDocsContentStatus, "getDocsContentStatus");

  // Opciones para tipo de carpeta.
  let folder = [];

  console.log(dataCase);

  if (dataCase?.company_relation?.id == 6) {
    folder = [
      { name: "Seleccionar", value: 0, displayName: "SELECCIONAR" },
      {
        name: "DOCUMENTACION VIABILIDAD",
        value: 1,
        displayName: normalizeFolderDisplayName("DOCUMENTACION VIABILIDAD"),
      },
      {
        name: "DOCUMENTACION INFORME COMPLETO",
        value: 2,
        displayName: normalizeFolderDisplayName(
          "DOCUMENTACION INFORME COMPLETO",
        ),
      },
      {
        name: "DOCUMENTACION ORDENADA Y WORD",
        value: 6,
        displayName: normalizeFolderDisplayName(
          "DOCUMENTACION ORDENADA Y WORD",
        ),
      },
      {
        name: "CUESTIONARIOS",
        value: 5,
        displayName: normalizeFolderDisplayName("CUESTIONARIOS"),
      },
      {
        name: "PERITAJE",
        value: 7,
        displayName: normalizeFolderDisplayName("PERITAJE"),
      },
      { name: "Sin Carpeta", value: 3, displayName: "SIN CARPETA" },
      { name: "Otro Nombre", value: 4, displayName: "OTRO NOMBRE" },
    ];
  } else {
    folder = [
      { name: "Seleccionar", value: 0, displayName: "SELECCIONAR" },
      {
        name: "Documental Demanda",
        value: 1,
        displayName: normalizeFolderDisplayName("Documental Demanda"),
      },
      {
        name: "INFORMES MEDICOS",
        value: 2,
        displayName: normalizeFolderDisplayName("INFORMES MEDICOS"),
      },
      {
        name: "PROVISION DE FONDOS",
        value: 5,
        displayName: normalizeFolderDisplayName("PROVISION DE FONDOS"),
      },
      { name: "Sin Carpeta", value: 3, displayName: "SIN CARPETA" },
      { name: "Otro Nombre", value: 4, displayName: "OTRO NOMBRE" },
    ];
  }

  // // Normaliza rutas para evitar barras duplicadas o invertidas
  // const normalizePath = (path) => {
  //   return path.replace(/\\/g, "/").replace(/\/+/g, "/");

  // Elimina múltiples documentos seleccionados por checkbox
  const deleteMultipleDocuments = () => {
    const allDocs = Object.values(selectedDocs).flat();

    if (allDocs?.length > 0) {
      Swal.fire({
        title: "¡Cuidado!",
        icon: "warning",
        text: `Está a punto de eliminar los archivos seleccionados`,
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        cancelButtonColor: "#d33",
        reverseButtons: true,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
      }).then(async (response) => {
        if (response.isConfirmed) {
          // Loader mientras se procesa la eliminación
          Swal.fire({
            title: "Eliminando archivos...",
            html: '<div class="swal-loader"></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
              Swal.showLoading();
            },
          });

          const formData = new FormData();
          formData.append("documents", JSON.stringify(allDocs));

          try {
            const { data } = await api.post(
              `${process.env.REACT_APP_API_URL}/s3/destroymultiple`,
              formData,
            );

            Swal.close(); // Cierra el loader

            if (data.success) {
              Swal.fire({
                title: "¡Archivos eliminados!",
                icon: "success",
                html: `Se han eliminado los archivos con éxito`,
                confirmButtonColor: "#1ab394",
                confirmButtonText: "Continuar",
              });

              // Fuerza recarga de documentos
              setDocsLoading(true);
              setDocsChangedFlag((prev) => !prev);

              setSelectedFolderTypeOption(null);
              setSelectedDocs({});
            } else if (data?.error?.errorInfo?.length > 0) {
              Swal.fire({
                title: "¡Ha ocurrido un error al eliminar los archivos!",
                icon: "error",
                confirmButtonColor: "#1ab394",
                confirmButtonText: "Continuar",
              });
            }
          } catch (error) {
            Swal.close();
            Swal.fire({
              title: "¡Error de conexión!",
              icon: "error",
              text: "No se pudo eliminar los archivos.",
              confirmButtonColor: "#1ab394",
              confirmButtonText: "Continuar",
            });
            console.error(error);
          }
        }
      });
    } else {
      Swal.fire({
        title: "¡Error!",
        icon: "error",
        text: `No se ha seleccionado ningún archivo`,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
      });
    }
  };

  const downloadAllDocuments = () => {
    if (!caseId) return;

    const url = `${process.env.REACT_APP_API_URL}/cases/${caseId}/download-all`;
    window.open(url, "_blank"); // Descarga directa del ZIP
  };

  // Confirma y pasa a la siguiente fase del flujo
  const handleCompletedDocu = () => {
    // Configuración de la siguiente fase (archivos requeridos)
    const config = {
      files: [
        "DNI/NIF/Pasaporte (ambas caras)",
        "Cuenta Bancaria con IBAN",
        "Autorización INSS",
        "Nº CARTILLA SEGURIDAD SOCIAL, RESOLUCIÓN DE SEGURIDAD SOCIAL SOBRE PENSIÓN DE JUBILACIÓN, INFORMES MÉDICOS ACTUALIZADOS",
      ],
    };

    const newMessage = `<div class="feed-element"><div><span class="label label-info pull-right">${dayjs().format(
      "DD/MM/YYYY HH:mm",
    )}</span><hr>Documentación Completada</div></div>`;

    let fullMessage = "";

    if (activeTask?.message) {
      fullMessage = newMessage + message;
    }

    Swal.fire({
      title: "¿Actualizar el caso?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      confirmButtonText: "Sí",
      reverseButtons: true,
      denyButtonText: "Volver",
    }).then((result) => {
      if (result.isConfirmed) {
        nextTask(
          config,
          1,
          "next",
          fullMessage != "" ? fullMessage : newMessage,
        ); // Llama a la función para avanzar en el proceso
      }
    });
  };

  const handleCancelProcess = () => {
    // Configuración de la siguiente fase (archivos requeridos)
    var config = {};

    try {
      Swal.fire({
        title: "¿Desea cancelar el proceso?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Sí",
        denyButtonText: "Volver",
      }).then((result) => {
        if (result.isConfirmed) {
          nextTask(
            activeTask?.config ? activeTask?.config : config,
            2,
            true,
            "",
          );
        }
      });
    } catch (err) {
      console.error("Error en handleCancelProcess:", err);
      // Fallback: mostrar alerta simple
      Swal.fire({
        title: "Error interno",
        text: "Ocurrió un error al procesar la acción. Reintenta o contacta soporte.",
        icon: "error",
        confirmButtonColor: "#d33",
      });
    }
  };

  const handleCompletePendingTask = () => {
    if (!activeTask?.id || !caseId) return;

    Swal.fire({
      title: "¿Dar por completada esta tarea?",
      text: "Solo se marcará la tarea actual como completada.",
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#1ab394",
      confirmButtonText: "Sí",
      reverseButtons: true,
      denyButtonText: "Volver",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        await api.post(
          `${process.env.REACT_APP_API_URL}/casestasks/complete-pending-task`,
          {
            id: Number(activeTask.id),
            case_id: Number(caseId),
          },
        );

        Swal.fire({
          title: "Guardado",
          text: "La tarea actual se completó correctamente.",
          icon: "success",
          confirmButtonColor: "#1ab394",
        });

        if (typeof setUpdatedCase === "function") {
          setUpdatedCase(!updatedCase);
        }
      } catch (error) {
        console.error("Error al completar tarea pendiente:", error);
        Swal.fire({
          title: "Error",
          text: "No se pudo completar la tarea actual.",
          icon: "error",
          confirmButtonColor: "#d33",
        });
      }
    });
  };

  const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const waitForDocsRender = () => {
    return new Promise((resolve) => {
      docsRenderResolverRef.current = resolve;
    });
  };

  const handleDocsRendered = () => {
    if (docsRenderResolverRef.current) {
      docsRenderResolverRef.current();
      docsRenderResolverRef.current = null;
    }
  };

  return (
    <Grid container item xs={12} sx={{ minHeight: "400px", fontSize: "14px" }}>
      {activeTask?.message && (
        <Grid item xs={12}>
          <div dangerouslySetInnerHTML={{ __html: activeTask?.message }} />
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sx={{
          border: "1px dashed #f4f9ff",
          p: "10px",
          backgroundColor: "#f4f9ff",
          height: "90px",
        }}
      >
        <b>Archivos descargables</b>
        <hr />
        <Button
          color="warning"
          size="small"
          variant="contained"
          component="a"
          href={`${process.env.REACT_APP_BACKEND_HOST}/storage/caseconfig/inss_authorization.pdf`}
          target="_blank"
          startIcon={
            <CustomIcons
              icon={InsertDriveFile}
              width={"18px"}
              height={"18px"}
            />
          }
        >
          <span className="reOrderTextButton">Autorización INSS NUEVA</span>
        </Button>
      </Grid>

      <Grid container item xs={12} sx={{ mt: 3, alignItems: "flex-start" }}>
        {canUploadDocs && (
          <Grid item xs={4} container>
            <Grid item xs={12} container sx={{ backgroundColor: "#f4f9ff" }}>
              <Grid item xs={12} p={"10px"}>
                <b>Subir documentación</b>
              </Grid>
              <Grid item xs={12} p={"10px"}>
                <Grid item xs={12} p={"10px"}>
                  <Autocomplete
                    size="small"
                    value={selectedFolderTypeOption}
                    onChange={(e, val) => {
                      setSelectedFolderTypeOption(
                        val?.name != "Seleccionar" ? val : null,
                      );
                    }}
                    options={folder}
                    getOptionLabel={(option) =>
                      option?.displayName ||
                      normalizeFolderDisplayName(option?.name) ||
                      ""
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Seleccionar metodo de subida"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                {/*  Aquí decides renderizar el modal */}
                {selectedFolderTypeOption && (
                  <UploaderDialog
                    userLogged={userLogged}
                    caseId={caseId}
                    effects={Transition}
                    setSelectedFolderTypeOption={setSelectedFolderTypeOption}
                    selectedFolderTypeOption={selectedFolderTypeOption}
                    setDocsChangedFlag={setDocsChangedFlag}
                    setDocsLoading={setDocsLoading}
                    docsChangedFlag={docsChangedFlag}
                    dataCase={dataCase}
                    waitForDocsRender={waitForDocsRender}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid
          container
          item
          xs={canUploadDocs ? 8 : 12}
          sx={{ paddingLeft: "10px" }}
        >
          <ArchivosMostrar
            caseId={caseId}
            userLogged={userLogged}
            setDocsChangedFlag={setDocsChangedFlag}
            docsChangedFlag={docsChangedFlag}
            selectedDocs={selectedDocs}
            setSelectedDocs={setSelectedDocs}
            dataCase={dataCase}
            activeTaskMessage={message}
            caseTasks={dataCase?.tasks}
            onDocsRendered={handleDocsRendered}
          />
        </Grid>

        <Grid item xs={4}>
          {sectionId == dataCase?.task?.task_id && canEdit && (
            <CustomButtonPlusIcon
              icon={Cancel}
              text={"CAMBIAR A DOCUMENTACIÓN CANCELADA"}
              handleFunction={handleCancelProcess}
              position={"start"}
              variant={"outlined"}
              color={"error"}
              fullWidth={true}
            />
          )}
        </Grid>

        <Grid
          container
          spacing={1}
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Grid item xs={4}>
            {canDeleteDocs && (
              <CustomButtonPlusIcon
                icon={Delete}
                text={"BORRAR SELECCIONADOS"}
                handleFunction={deleteMultipleDocuments}
                position={"start"}
                variant={"contained"}
                color={"error"}
                fullWidth={true}
              />
            )}
          </Grid>
          <Grid item xs={4}>
            <CustomButtonPlusIcon
              icon={InsertDriveFile}
              text={"DESCARGAR TODA LA DOCUMENTACIÓN"}
              handleFunction={downloadAllDocuments}
              position={"start"}
              variant={"contained"}
              color={"primary"}
              fullWidth={true}
            />
          </Grid>
          <Grid item xs={4}>
            {shouldShowCompletePendingTaskButton ? (
              // || getDocsContentStatus
              <CustomButtonPlusIcon
                icon={ArrowForwardIos}
                text={"Dar por completada la tarea"}
                handleFunction={handleCompletePendingTask}
                position={"end"}
                variant={"contained"}
                color={"success"}
                fullWidth={true}
              />
            ) : getDocsContentStatus ||
              (sectionId == dataCase?.task?.task_id && canEdit) ? (
              <CustomButtonPlusIcon
                icon={ArrowForwardIos}
                text={"Documentación completa"}
                handleFunction={handleCompletedDocu}
                position={"end"}
                variant={"contained"}
                color={"success"}
                fullWidth={true}
              />
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DocsContent;
